import styled from '@emotion/styled';
import { Statistic, StatisticProps } from 'antd';
import { Bar, BarChart, ResponsiveContainer } from 'recharts';
import { useNavigate } from 'react-router';
import { colors, Icon, Title } from 'common-components';

type StatisticItemType = Omit<StatisticProps, 'styles'> & {
  styles?: { content?: React.CSSProperties }
};

export type StatisticsCardPropsType = {
  statistics?: StatisticItemType[]
  graphData?: any
  title?: string
  chartColor?: string
  link?: string
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  border-radius: 10px;
  background-color: ${colors.gray800};
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
`;
const StatisticsRow = styled.div`
  display: flex;
  gap: 10px;

  & > * {
    flex: 1;
  }
`;
const StatisticsCard = ({ title, statistics = [], chartColor, link }: StatisticsCardPropsType) => {
  const navigate = useNavigate();
  const data = [
    {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: 'Page C',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: 'Page D',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: 'Page E',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: 'Page F',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  return (
    <Container>
      <Header onClick={() => navigate(link)}>
        <Title style={{ fontWeight: 600, fontSize: 20, lineHeight: '30px', color: colors.white }}>
          {title}
        </Title>
        <Icon icon={'AndroidOpen1'} size={24} />
      </Header>
      <StatisticsRow>
        {statistics.map(({ styles, ...item }, index) => (
          <Statistic
            key={index}
            {...item}
            styles={{
              header: { paddingBottom: 0 },
              title: { marginBottom: 0, color: colors.white, fontWeight: 400, fontSize: 10, lineHeight: '13px' },
              content: { color: colors.white, fontWeight: 600, fontSize: 18, lineHeight: '30px', ...styles?.content },
            }}
          />
        ))}
      </StatisticsRow>
      <ResponsiveContainer width="100%" height={83}>
        <BarChart
          data={[...data, ...data, ...data]}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          barCategoryGap={4}
        >
          <Bar dataKey="uv" fill={chartColor || colors.primary400} strokeOpacity={0} radius={[10, 10, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default StatisticsCard;
